import DateTimeUtils from 'src/utils/datetime';
import { ScheduleChild } from '../interfaces/ScheduleChild.interface';
import { ScheduleSubject } from '../interfaces/ScheduleSubject.interface';
import axiosApiInstance from 'src/api/axiosConfig';

export const fetchChildrenData = async (
    educationLevelRange: string,
    subjectId: ScheduleSubject['id'],
    rangeStart: Date,
    educationCenterId?: number
): Promise<ScheduleChild[]> => {
    const params = new URLSearchParams({
        targetGradeRange: educationLevelRange,
        subjectId: subjectId.toString(),
        weekDate: DateTimeUtils.getFormattedDate(rangeStart),
        educationCenterId: educationCenterId ? educationCenterId.toString() : ''
    });

    const { data } = await axiosApiInstance.get(`children?${params.toString()}`);

    return data;
};
